import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAssignedBidPostData } from "Shared/Types/api";
import api from 'Service/api/api';

export const getBidList = createAsyncThunk(
  `bid/getBidList`,
  async ({
    page,
    pageSize,
    isHistorical,
  }: {
    page?: number;
    pageSize?: number;
    isHistorical?: boolean;
  }) => {
    try {
      const response = await api.bid.getBidList({
        page,
        pageSize,
        isHistorical,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getBid = createAsyncThunk(`bid/getBid`, async (id: number) => {
  try {
    const response = await api.bid.getBid(id);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const assignBid = createAsyncThunk(
  `bid/assignBid`,
  async (data: IAssignedBidPostData) => {
    try {
      const response = await api.bid.assignBid(data);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);
